// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E_vkN7 {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: var(--spacing-3);
}

._79wnii {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background-color: var(--surface-primary-subtle);
  border-radius: 50%;
}

.bzmQQJ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.sjtm5M {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background: var(--card-background, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));
  overflow: hidden;
}

.QMsYJY {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);
  gap: var(--spacing-3, 24px);
  flex: 1;
  min-height: 0;
}

.YZqcYB {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--background-alt);
  padding-bottom: var(--spacing-3);
}

.DR3YBb {
  display: flex;
  flex: 1;
  gap: var(--spacing-3);
  min-height: 100%;
  height: 100%;
}

.BrWfel {
  flex: 1;
  background-color: var(--surface-neutral-white);
  width: 100%;
  height: 100%;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 14px;
  color: #1f1f1f;
  font-family: var(--font-family-base);
}

.ytc7uG {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: var(--surface-neutral-white);
}

.CaqtSE {
  width: 355px;
  height: 100%;
}

.d65KLk {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2);
  background-color: var(--surface-neutral-white);
  padding: 15px;
}

.xdwlFD {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--surface-neutral-white);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-primary-medium);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}

.RL7syt {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}
.RL7syt:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface);
  color: var(--text-neutral-strong);
  border: 2px solid var(--disabled-subtle-surface);
}

.bMuQgx {
  height: 72px;
  width: 72px;
}

.dbM_nE {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
}

.FEE7NR {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: center;
  width: auto;
  max-width: 270px;
}

.Sz0imy {
  height: 40px;
  min-width: 166px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/BilletAccountPayable/BilletAccountPayable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mCAAmC;EACnC,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;EAC7E,2BAA2B;EAC3B,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;EACjC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".fullCenterColumn {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  gap: var(--spacing-3);\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  background-color: var(--surface-primary-subtle);\n  border-radius: 50%;\n}\n\n.mediumSemiboldText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  background: var(--card-background, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));\n  overflow: hidden;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n  gap: var(--spacing-3, 24px);\n  flex: 1;\n  min-height: 0;\n}\n\n.layoutRoot {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: var(--background-alt);\n  padding-bottom: var(--spacing-3);\n}\n\n.layoutContent {\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-3);\n  min-height: 100%;\n  height: 100%;\n}\n\n.mainContent {\n  flex: 1;\n  background-color: var(--surface-neutral-white);\n  width: 100%;\n  height: 100%;\n  position: relative;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  box-sizing: border-box;\n  gap: 24px;\n  text-align: left;\n  font-size: 14px;\n  color: #1f1f1f;\n  font-family: var(--font-family-base);\n}\n\n.footerContent {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  background-color: var(--surface-neutral-white);\n}\n\n.sideContent {\n  width: 355px;\n  height: 100%;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2);\n  background-color: var(--surface-neutral-white);\n  padding: 15px;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-neutral-white);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-primary-medium);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n\n.nextButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n.nextButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface);\n  color: var(--text-neutral-strong);\n  border: 2px solid var(--disabled-subtle-surface);\n}\n\n.errorImage {\n  height: 72px;\n  width: 72px;\n}\n\n.errorTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n}\n\n.errorCaption {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  width: auto;\n  max-width: 270px;\n}\n\n.errorActionButton {\n  height: 40px;\n  min-width: 166px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullCenterColumn": `E_vkN7`,
	"loader": `_79wnii`,
	"mediumSemiboldText": `bzmQQJ`,
	"container": `sjtm5M`,
	"content": `QMsYJY`,
	"layoutRoot": `YZqcYB`,
	"layoutContent": `DR3YBb`,
	"mainContent": `BrWfel`,
	"footerContent": `ytc7uG`,
	"sideContent": `CaqtSE`,
	"footer": `d65KLk`,
	"backButton": `xdwlFD`,
	"nextButton": `RL7syt`,
	"errorImage": `bMuQgx`,
	"errorTitle": `dbM_nE`,
	"errorCaption": `FEE7NR`,
	"errorActionButton": `Sz0imy`
};
module.exports = ___CSS_LOADER_EXPORT___;
